import {forwardRef} from 'react';
import {Autocomplete, CircularProgress, TextField} from '@mui/material';

import {useGetSubCategories} from '../../apiHooks';
import {SubCategory} from '../../types';

type Props = {
  value: SubCategory | null;
  onChange: (value: SubCategory | null) => void;
  categoryId: string;
  label?: string;
  error?: string;
  fullWidth?: boolean;
  disabled?: boolean;
};

export const SubCategorySelect = forwardRef<HTMLInputElement, Props>(
  ({value, onChange, categoryId, label, error, fullWidth, disabled}, ref) => {
    const {data: options = [], isPending} = useGetSubCategories(categoryId, {
      enabled: !!categoryId,
    });

    return (
      <Autocomplete
        ref={ref}
        value={value}
        options={options}
        loading={isPending}
        disabled={disabled || !categoryId}
        fullWidth={fullWidth}
        getOptionLabel={option => option.name || option.id}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        onChange={(_, newValue) => onChange(newValue)}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            error={!!error}
            helperText={error}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isPending && <CircularProgress size={16} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    );
  },
);
